/**
 * Run all sagas
 */

import { all } from 'typed-redux-saga';
import { catalogueRootSaga } from 'containers/catalogue/catalogue/saga';
import { instoreRootSaga } from 'containers/instore/saga';
import { instoreServiceRootSaga } from 'containers/instore/';
import { configuratorsListingRootSaga } from 'containers/configurators-listing';
import { roughWorkSaga } from 'containers/rough-work/saga';
import { pageModelRootSaga } from './pageModel';

// [IMPORT NEW SLICESAGA ABOVE] < Needed for generating slices seamlessly

export function* rootSaga(): Generator<unknown> {
	yield all([
		pageModelRootSaga(),
		catalogueRootSaga(),
		instoreRootSaga(),
		instoreServiceRootSaga(),
		configuratorsListingRootSaga(),
		roughWorkSaga(),
		// [INSERT NEW SLICE SAGA ABOVE] < Needed for generating slices seamlessly
	]);
}
